// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageSecurityDeposit-space1-SIboX {
	margin-bottom: 6px !important;
}

.ManageSecurityDeposit-space2-B5y2U {
	margin-bottom: 12px !important;
}

.ManageSecurityDeposit-space3-Op9pJ {
	margin-bottom: 18px !important;
}

.ManageSecurityDeposit-space4-h6atO {
	margin-bottom: 24px !important;
}

.ManageSecurityDeposit-space5-uyxi3 {
	margin-bottom: 30px !important;
}

.ManageSecurityDeposit-space6-wVNHy {
	margin-bottom: 36px !important;
}

.ManageSecurityDeposit-space7-eB5Z6 {
	margin-bottom: 42px !important;
}

.ManageSecurityDeposit-space8-n14Io {
	margin-bottom: 48px !important;
}

.ManageSecurityDeposit-spaceTop1-U1uPE {
	margin-top: 6px !important;
}

.ManageSecurityDeposit-spaceTop2-CXB42 {
	margin-top: 12px !important;
}

.ManageSecurityDeposit-spaceTop3-iuL_j {
	margin-top: 18px !important;
}

.ManageSecurityDeposit-spaceTop4-ex4Em {
	margin-top: 24px !important;
}

.ManageSecurityDeposit-spaceTop5-cEyah {
	margin-top: 30px !important;
}

.ManageSecurityDeposit-spaceTop6-SIrIi {
	margin-top: 36px !important;
}

.ManageSecurityDeposit-spaceTop7-wNDzo {
	margin-top: 42px !important;
}

.ManageSecurityDeposit-spaceTop8-Wvh23 {
	margin-top: 48px !important;
}

.ManageSecurityDeposit-noMargin-brx82 {
	margin: 0px !important;
}

.ManageSecurityDeposit-padding1-b4Gl0 {
	padding-bottom: 6px !important;
}

.ManageSecurityDeposit-padding2-kPiJD {
	padding-bottom: 12px !important;
}

.ManageSecurityDeposit-padding3-VCN0q {
	padding-bottom: 18px !important;
}

.ManageSecurityDeposit-padding4-SlvyF {
	padding-bottom: 24px !important;
}

.ManageSecurityDeposit-padding5-wJYhW {
	padding-bottom: 30px !important;
}

.ManageSecurityDeposit-padding6-SykvC {
	padding-bottom: 36px !important;
}

.ManageSecurityDeposit-padding7-MaKG6 {
	padding-bottom: 42px !important;
}

.ManageSecurityDeposit-paddingTop1-xCQP0 {
	padding-top: 6px !important;
}

.ManageSecurityDeposit-paddingTop2-GziER {
	padding-top: 12px !important;
}

.ManageSecurityDeposit-paddingTop3-_rqn6 {
	padding-top: 18px !important;
}

.ManageSecurityDeposit-paddingTop4-rV3Vh {
	padding-top: 24px !important;
}

.ManageSecurityDeposit-paddingTop5-f721Y {
	padding-top: 30px !important;
}

.ManageSecurityDeposit-paddingTop6-J42MZ {
	padding-top: 36px !important;
}

.ManageSecurityDeposit-paddingTop7-Y_L2G {
	padding-top: 42px !important;
}

.ManageSecurityDeposit-noPadding-ZBa7y {
	padding: 0px !important;
}

.ManageSecurityDeposit-spaceMarginBottom0-bKfEf {
	margin-bottom: 0;
}

.ManageSecurityDeposit-textBold-C2zhM {
	font-weight: 500 !important;
}

.ManageSecurityDeposit-textBolder-unc6X {
	font-weight: 700 !important;
}

.ManageSecurityDeposit-textNormal-CoPUJ {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ManageSecurityDeposit-textDarkBlue-jVd9h {
	color: rgb(20, 39, 94) !important;
}

.ManageSecurityDeposit-textLightBlue-y7j7V {
	color: rgb(57, 87, 106) !important;
}

.ManageSecurityDeposit-textLightSandleGreen-YmjWE {
	color: rgb(76, 86, 41) !important;
}

.ManageSecurityDeposit-textLightBrown-LvbI9 {
	color: rgb(115, 79, 33) !important;
}

.ManageSecurityDeposit-textMediumMaroon-_3GbW {
	color: rgb(87, 37, 51) !important;
}

.ManageSecurityDeposit-textBrown-ZU8Qw {
	color: rgb(160, 47, 24) !important;
}

.ManageSecurityDeposit-textMaroon-I2boX {
	color: rgb(155, 49, 67) !important;
}

.ManageSecurityDeposit-textDarkBrown-y_XJl {
	color: rgb(83, 18, 16) !important;
}

.ManageSecurityDeposit-textMediumBrown-xGleo {
	color: rgb(142, 28, 10) !important;
}

.ManageSecurityDeposit-textSkyBlue-u_xQm {
	color: rgb(37, 117, 141) !important;
}

.ManageSecurityDeposit-textGray-MCGF_ {
	color: rgb(77, 65, 51) !important;
}

.ManageSecurityDeposit-errorMessage-py2tN {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ManageSecurityDeposit-userText-Ynr7C {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ManageSecurityDeposit-panelHeader-e0nEi {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ManageSecurityDeposit-exportSection-vngiY {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ManageSecurityDeposit-exportSectionGridSub-jvhPy {
	grid-template-columns: 50% 49% !important;
}

.ManageSecurityDeposit-exportText-IFw9O {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ManageSecurityDeposit-exportLinkImg-ThpnH {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ManageSecurityDeposit-exportImg-NHsx_ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ManageSecurityDeposit-linkBtn-NsUrg {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ManageSecurityDeposit-table-cvqwF {
	display: table;
}

.ManageSecurityDeposit-tableRow-QxTiZ {
	display: table-row;
}

.ManageSecurityDeposit-tableCell-xsNlz {
	display: table-cell;
	float: none;
}

.ManageSecurityDeposit-formGroup-ucFKD {
	margin-bottom: 6px;
}

.ManageSecurityDeposit-marginTop0-V_Vu4 {
	margin-top: 0;
}

.ManageSecurityDeposit-marginBottom20-UBCsG {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ManageSecurityDeposit-bannerImageBg-Ilnhj {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ManageSecurityDeposit-bannerDelete-Tljyw {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ManageSecurityDeposit-exportLink-iUvEB {
	padding-top: 10px;
	padding-right: 10px;
}

.ManageSecurityDeposit-seachContent-oPT_3 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ManageSecurityDeposit-marginBottom9-hmpbX {
	margin-bottom: 9px;
}

.ManageSecurityDeposit-spaceTop52-G044y {
	margin-top: 52px;
}

.ManageSecurityDeposit-profileViewInner-_jmT2 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ManageSecurityDeposit-profileViewMain-Ev1sf {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ManageSecurityDeposit-profileViewlabel-efCLB {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ManageSecurityDeposit-profileViewMainContent-O2l1I {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ManageSecurityDeposit-reviewsFormStar-vlk02 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ManageSecurityDeposit-reviewsFormStar-vlk02 svg {
	cursor: pointer;
}

.ManageSecurityDeposit-addLanguageText-klGJv {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ManageSecurityDeposit-exportSection-vngiY {
		grid-template-columns: 100%;
	}

	.ManageSecurityDeposit-spaceTop52-G044y {
		margin-top: 18px;
	}

	.ManageSecurityDeposit-exportText-IFw9O {
		float: none;
		margin-top: 12px;
	}

	.ManageSecurityDeposit-exportSectionGridSub-jvhPy {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ManageSecurityDeposit-profileViewlabel-efCLB {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ManageSecurityDeposit-profileViewMainContent-O2l1I {
		width: 100%;
		text-align: center;
	}

	.ManageSecurityDeposit-panelHeader-e0nEi {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ManageSecurityDeposit-btn-lQ5Gu,
.ManageSecurityDeposit-btn-lQ5Gu:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 8px 12px 8px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btn-lQ5Gu:hover {
	background: var(--common-background-color) !important;
	outline: 0 !important;
	color: var(--white-text) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btn-lQ5Gu:hover img {
	-webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
	        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
}

.ManageSecurityDeposit-btnPrimary-mL9yU,
.ManageSecurityDeposit-btnPrimary-mL9yU:focus {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btnPrimary-mL9yU:hover {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btnPrimaryBorder-ua6fZ,
.ManageSecurityDeposit-btnPrimaryBorder-ua6fZ:focus {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	border-radius: 6px;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}

.ManageSecurityDeposit-btnPrimaryBorder-ua6fZ:hover {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	text-decoration: none !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btnSecondary-oDulg,
.ManageSecurityDeposit-btnSecondary-oDulg:focus {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-bg) !important;
	color: var(--white-text) !important;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	white-space: pre-line;
}

.ManageSecurityDeposit-btnSecondary-oDulg:hover {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-hover-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btnLink-dGV4K,
.ManageSecurityDeposit-btnLink-dGV4K:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	width: auto !important;
	outline: 0 !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}

.ManageSecurityDeposit-btnLink-dGV4K:hover {
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	outline: 0 !important;
	text-decoration: underline;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	border: 0px !important;
}

.ManageSecurityDeposit-btnLinkPrimary-iHdhF,
.ManageSecurityDeposit-btnLinkPrimary-iHdhF:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btnLinkPrimary-iHdhF:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}

.ManageSecurityDeposit-btnLinkSecondary-TivqD,
.ManageSecurityDeposit-btnLinkSecondary-TivqD:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-size: 16px;
	font-weight: 500;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0 !important;
	padding: 0 !important;
}

.ManageSecurityDeposit-btnLinkSecondary-TivqD:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-weight: 500;
	text-decoration: none !important;
	border-bottom: 1px solid var(--common-link-color) !important;
}

.ManageSecurityDeposit-searchFilterPopover-uRMe6 {
	position: absolute;
	top: 57px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	visibility: visible;
	background: var(--primary-white-bg);
	-o-border-image: initial;
	   border-image: initial;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
	border-radius: 12px;
}

.ManageSecurityDeposit-searchFilterPopoverFull-BlWTl {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background: var(--primary-white-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}

.ManageSecurityDeposit-searchFilterPopoverOverlay-cPzEo {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	bottom: 0;
}

.ManageSecurityDeposit-searchFilterPopoverContent-tG0Jr {
	min-width: 370px;
	padding: 26px 26px 16px;
	height: 294px;
}

.ManageSecurityDeposit-searchFilterCloseIcon-I393W {
	font-size: 30px;
	color: var(--modalText-color);
}

.ManageSecurityDeposit-searchFilterPopoverFooter-fjqLF {
	width: 100%;
	position: relative;
	line-height: 0;
}

.ManageSecurityDeposit-displayTable-OzyEo {
	display: table;
	width: 100%;
	vertical-align: middle;
}

.ManageSecurityDeposit-displayTableRow-Wo1YI {
	display: table-row;
	vertical-align: middle;
}

.ManageSecurityDeposit-displayTableCell-BJHnr {
	display: table-cell;
	vertical-align: middle;
}

.ManageSecurityDeposit-displayInlineBlock-SO4HX {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}

.ManageSecurityDeposit-fullWidth-xLCQU {
	width: 100% !important;
}

.ManageSecurityDeposit-captionTitle-nSeQO {
	font-size: 18px;
}

.ManageSecurityDeposit-showTabletSection-kbXD5 {
	display: none !important;
}

.ManageSecurityDeposit-incrementDecrementButton-pr2Vz {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	display: block;
	overflow: hidden;
	-webkit-appearance: none;
}

.ManageSecurityDeposit-commonBorder-WMPan {
	border: 1px solid transparent !important;
	color: var(--modalText-color) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 60px !important;
	box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-appearance: none !important;
}

.ManageSecurityDeposit-textCenter-tXqg5 {
	text-align: center;
}

@media screen and (max-width: 768px) {
	.ManageSecurityDeposit-searchFilterPopoverFull-BlWTl {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		border: 1px solid var(--primary-white-bg);
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.ManageSecurityDeposit-searchFilterPopoverContent-tG0Jr {
		min-width: 320px;
		padding: 15px 15px 70px !important;
		height: 100%;
		min-height: 50vh;
		overflow: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.ManageSecurityDeposit-searchFilterPopoverHeader-ht8Eo {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 10px 15px;
		background: var(--primary-white-bg);
	}

	.ManageSecurityDeposit-searchFilterPopoverFooter-fjqLF {
		font-weight: 600;
		position: fixed;
		top: 38%;
		left: 0;
		right: 0;
		background-color: transparent;
		z-index: 10;
	}

	.ManageSecurityDeposit-textSize-ReH7S {
		font-size: 20px;
		font-weight: 600;
		display: block;
		width: 100% !important;
		height: 45px;
	}
}

.ManageSecurityDeposit-capitalizeText-lxxa0 {
	text-transform: capitalize;
}

.ManageSecurityDeposit-hideBothTabletAndMobile-M8vGO {
	display: inline-block;
}

@media (max-width: 1199px) {
	.ManageSecurityDeposit-hideBothTabletAndMobile-M8vGO {
		display: none !important;
	}
}

@media screen and (max-width: 350px) {
	.ManageSecurityDeposit-btnFontsize-xy7uQ {
		font-size: 12px !important;
	}
}

@media (max-width: 360px) {
	.ManageSecurityDeposit-searchFilterCloseIcon-I393W {
		font-size: 25px;
	}
}

.ManageSecurityDeposit-transmissionBottom-JeOXs {
	padding-bottom: 21px !important;
}

.ManageSecurityDeposit-marginTop20-E7IuW {
	margin-top: 35px;
}

.ManageSecurityDeposit-marginRight15-_NNbP {
	margin-right: 15px !important;
}

.ManageSecurityDeposit-marginNone-MsrVu {
	margin: 0 !important;
}

.ManageSecurityDeposit-paddingNone-plwFB {
	padding: 0 !important;
}

.ManageSecurityDeposit-infoPadding-euIiL {
	padding-right: 6px;
}

@media(min-width:768px) {
	.ManageSecurityDeposit-pullRight-dFgOM {
		float: right;
	}
}

.ManageSecurityDeposit-displayFlex-k5o5s {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

@media(max-width:767px) {

	.ManageSecurityDeposit-displayFlex-k5o5s {
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}

	.ManageSecurityDeposit-hideTabletSection-cWZth {
		display: none !important;
	}

	.ManageSecurityDeposit-showTabletSection-kbXD5 {
		display: block !important;
	}
}

/*****************Apply Button Alignment Start **********************/

.ManageSecurityDeposit-applyBtnDesktop-KCN_m {
	text-align: right;
}

.ManageSecurityDeposit-applyBtn-uFD1v,
.ManageSecurityDeposit-applyBtn-uFD1v:hover,
.ManageSecurityDeposit-applyBtn-uFD1v:active,
.ManageSecurityDeposit-applyBtn-uFD1v:focus {
	background-color: var(--common-background-color) !important;
	color: var(--white-text) !important;
	border-radius: 6px;
	text-decoration: none;
	padding: 9px 15px 10px;
	font-size: 16px;
}

@media screen and (max-width: 991px) {
	.ManageSecurityDeposit-applyBtnDesktop-KCN_m {
		text-align: center;
	}

	.ManageSecurityDeposit-applyBtnDesktopRight-JuR_q {
		text-align: right !important;
	}

	.ManageSecurityDeposit-applyBtnDesktopNoPaddingRight-bKgPA {
		padding-right: 0px !important;
	}
}

@media screen and (max-width: 767px) {
	.ManageSecurityDeposit-searchFilterPopoverFooter-fjqLF {
		position: relative !important;
		top: inherit;
	}
}

/*****************Apply Button Alignment Start **********************/

/*************************** Header Modal Start **********************/

.ManageSecurityDeposit-activeItem-mAtCp {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 6px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.ManageSecurityDeposit-activeItem-mAtCp:hover,
.ManageSecurityDeposit-activeItem-mAtCp:focus,
.ManageSecurityDeposit-activeItem-mAtCp:active {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border-radius: 6px;
}

.ManageSecurityDeposit-activeSection-bbYNG:first-child {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ManageSecurityDeposit-currencyAndLangGrid-VLpKD {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 12px;
}

@media (max-width:767px) {
	.ManageSecurityDeposit-currencyAndLangGrid-VLpKD {
		grid-template-columns: repeat(2, 1fr);
	}
}

/*************************** Header Modal End **********************/

.ManageSecurityDeposit-ChangeToUpperCase-w_FZP{
    text-transform: uppercase;
}

.ManageSecurityDeposit-marginBottom-QGGPN{
    margin-bottom: 20px;
}

.ManageSecurityDeposit-active-qBVRZ, .ManageSecurityDeposit-active-qBVRZ:hover, .ManageSecurityDeposit-active-qBVRZ:focus, .ManageSecurityDeposit-active-qBVRZ:active, .ManageSecurityDeposit-active-qBVRZ:active:hover {
    background-color: var(--btn-primary-bg) !important;
    color: var(--btn-secondary-color) !important;
}

.ManageSecurityDeposit-marginLR-SD6X_{
    margin: 0 12px;
}

@media screen and (max-width: 767px) {
.ManageSecurityDeposit-mbFullWidth-rCqhW{
    width: 100%;
    margin-bottom: 12px;
}
.ManageSecurityDeposit-marginLR-SD6X_{
    margin-bottom: 12px;
    margin-left: 0;
    margin-right: 0;
}
.ManageSecurityDeposit-mbFullWidth-rCqhW:last-child{
    margin-bottom: 0px;
}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/common.css","webpack://./src/components/siteadmin/ManageSecurityDeposit/ManageSecurityDeposit.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACrN3E;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,gCAAgC;CAChC,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;AACjB;;AAEA;CACC,qDAAqD;CACrD,qBAAqB;CACrB,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,qGAA6F;SAA7F,6FAA6F;AAC9F;;AAEA;;CAEC,8CAA8C;CAC9C,kDAAkD;CAClD,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,oDAAoD;CACpD,wDAAwD;CACxD,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;;CAEC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,sCAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;;CAEC,kDAAkD;CAClD,oDAAoD;CACpD,mCAAmC;CACnC,gCAAgC;CAChC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,kDAAkD;CAClD,0DAA0D;CAC1D,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qBAAqB;CACrB,0BAA0B;CAC1B,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,4DAA4D;CAC5D,2BAA2B;CAC3B,qBAAqB;AACtB;;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;CAChB,gCAAgC;CAChC,4DAA4D;AAC7D;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,mCAAmC;CACnC,wBAAqB;IAArB,qBAAqB;CACrB,yCAAiC;SAAjC,iCAAiC;CACjC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,wBAAwB;AACzB;;AAEA;CACC,wCAAwC;CACxC,wCAAwC;CACxC,mCAA2B;SAA3B,2BAA2B;CAC3B,8BAA8B;CAC9B,6CAA6C;CAC7C,qDAAqD;CACrD,mCAAmC;AACpC;;AAGA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mCAAmC;CACpC;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;CACb;AACD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;AAChB;;AAEA;;CAEC;EACC,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,yBAAyB;CAC1B;AACD;;AAEA,qEAAqE;;AAErE;CACC,iBAAiB;AAClB;;AAEA;;;;CAIC,2DAA2D;CAC3D,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,6BAA6B;EAC7B,YAAY;CACb;AACD;;AAEA,qEAAqE;;AACrE,sEAAsE;;AACtE;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;;;CAGC,gDAAgD;CAChD,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,gDAAgD;CAChD,wBAAwB;CACxB,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;;AAEA,oEAAoE;;ACrdpE;IACI,yBAAyB;AAC7B;;AACA;IACI,mBAAmB;AACvB;;AACA;IACI,kDAAkD;IAClD,4CAA4C;AAChD;;AACA;IACI,cAAc;AAClB;;AACA;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 8px 12px 8px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover {\n\tbackground: var(--common-background-color) !important;\n\toutline: 0 !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover img {\n\tfilter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\tborder-radius: 6px;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\tbox-shadow: inherit !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\ttext-decoration: none !important;\n\tfont-weight: 500;\n}\n\n.btnSecondary,\n.btnSecondary:focus {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\twhite-space: pre-line;\n}\n\n.btnSecondary:hover {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-hover-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnLink,\n.btnLink:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.btnLink:hover {\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\toutline: 0 !important;\n\ttext-decoration: underline;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tborder: 0px !important;\n}\n\n.btnLinkPrimary,\n.btnLinkPrimary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkPrimary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkSecondary,\n.btnLinkSecondary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0 !important;\n\tpadding: 0 !important;\n}\n\n.btnLinkSecondary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-weight: 500;\n\ttext-decoration: none !important;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 57px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tvisibility: visible;\n\tbackground: var(--primary-white-bg);\n\tborder-image: initial;\n\tbox-shadow: 0px 3px 6px #00000029;\n\tborder-radius: 12px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.searchFilterPopoverContent {\n\tmin-width: 370px;\n\tpadding: 26px 26px 16px;\n\theight: 294px;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--modalText-color);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 18px;\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tdisplay: block;\n\toverflow: hidden;\n\t-webkit-appearance: none;\n}\n\n.commonBorder {\n\tborder: 1px solid transparent !important;\n\tcolor: var(--modalText-color) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 60px !important;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-appearance: none !important;\n}\n\n\n.textCenter {\n\ttext-align: center;\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tborder: 1px solid var(--primary-white-bg);\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\tmin-width: 320px;\n\t\tpadding: 15px 15px 70px !important;\n\t\theight: 100%;\n\t\tmin-height: 50vh;\n\t\toverflow: hidden;\n\t\toverflow-y: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 10px 15px;\n\t\tbackground: var(--primary-white-bg);\n\t}\n\n\t.searchFilterPopoverFooter {\n\t\tfont-weight: 600;\n\t\tposition: fixed;\n\t\ttop: 38%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground-color: transparent;\n\t\tz-index: 10;\n\t}\n\n\t.textSize {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\theight: 45px;\n\t}\n}\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n.hideBothTabletAndMobile {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1199px) {\n\t.hideBothTabletAndMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n.transmissionBottom {\n\tpadding-bottom: 21px !important;\n}\n\n.marginTop20 {\n\tmargin-top: 35px;\n}\n\n.marginRight15 {\n\tmargin-right: 15px !important;\n}\n\n.marginNone {\n\tmargin: 0 !important;\n}\n\n.paddingNone {\n\tpadding: 0 !important;\n}\n\n.infoPadding {\n\tpadding-right: 6px;\n}\n\n@media(min-width:768px) {\n\t.pullRight {\n\t\tfloat: right;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n}\n\n@media(max-width:767px) {\n\n\t.displayFlex {\n\t\tjustify-content: space-between;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n.applyBtn,\n.applyBtn:hover,\n.applyBtn:active,\n.applyBtn:focus {\n\tbackground-color: var(--common-background-color) !important;\n\tcolor: var(--white-text) !important;\n\tborder-radius: 6px;\n\ttext-decoration: none;\n\tpadding: 9px 15px 10px;\n\tfont-size: 16px;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t\ttop: inherit;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n/*************************** Header Modal Start **********************/\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder-radius: 6px;\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.currencyAndLangGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 12px;\n}\n\n@media (max-width:767px) {\n\t.currencyAndLangGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/","@import '../admin-common.css';\n@import '../../common.css';\n.ChangeToUpperCase{\n    text-transform: uppercase;\n}\n.marginBottom{\n    margin-bottom: 20px;\n}\n.active, .active:hover, .active:focus, .active:active, .active:active:hover {\n    background-color: var(--btn-primary-bg) !important;\n    color: var(--btn-secondary-color) !important;\n}\n.marginLR{\n    margin: 0 12px;\n}\n@media screen and (max-width: 767px) {\n.mbFullWidth{\n    width: 100%;\n    margin-bottom: 12px;\n}\n.marginLR{\n    margin-bottom: 12px;\n    margin-left: 0;\n    margin-right: 0;\n}\n.mbFullWidth:last-child{\n    margin-bottom: 0px;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ManageSecurityDeposit-space1-SIboX`,
	"space2": `ManageSecurityDeposit-space2-B5y2U`,
	"space3": `ManageSecurityDeposit-space3-Op9pJ`,
	"space4": `ManageSecurityDeposit-space4-h6atO`,
	"space5": `ManageSecurityDeposit-space5-uyxi3`,
	"space6": `ManageSecurityDeposit-space6-wVNHy`,
	"space7": `ManageSecurityDeposit-space7-eB5Z6`,
	"space8": `ManageSecurityDeposit-space8-n14Io`,
	"spaceTop1": `ManageSecurityDeposit-spaceTop1-U1uPE`,
	"spaceTop2": `ManageSecurityDeposit-spaceTop2-CXB42`,
	"spaceTop3": `ManageSecurityDeposit-spaceTop3-iuL_j`,
	"spaceTop4": `ManageSecurityDeposit-spaceTop4-ex4Em`,
	"spaceTop5": `ManageSecurityDeposit-spaceTop5-cEyah`,
	"spaceTop6": `ManageSecurityDeposit-spaceTop6-SIrIi`,
	"spaceTop7": `ManageSecurityDeposit-spaceTop7-wNDzo`,
	"spaceTop8": `ManageSecurityDeposit-spaceTop8-Wvh23`,
	"noMargin": `ManageSecurityDeposit-noMargin-brx82`,
	"padding1": `ManageSecurityDeposit-padding1-b4Gl0`,
	"padding2": `ManageSecurityDeposit-padding2-kPiJD`,
	"padding3": `ManageSecurityDeposit-padding3-VCN0q`,
	"padding4": `ManageSecurityDeposit-padding4-SlvyF`,
	"padding5": `ManageSecurityDeposit-padding5-wJYhW`,
	"padding6": `ManageSecurityDeposit-padding6-SykvC`,
	"padding7": `ManageSecurityDeposit-padding7-MaKG6`,
	"paddingTop1": `ManageSecurityDeposit-paddingTop1-xCQP0`,
	"paddingTop2": `ManageSecurityDeposit-paddingTop2-GziER`,
	"paddingTop3": `ManageSecurityDeposit-paddingTop3-_rqn6`,
	"paddingTop4": `ManageSecurityDeposit-paddingTop4-rV3Vh`,
	"paddingTop5": `ManageSecurityDeposit-paddingTop5-f721Y`,
	"paddingTop6": `ManageSecurityDeposit-paddingTop6-J42MZ`,
	"paddingTop7": `ManageSecurityDeposit-paddingTop7-Y_L2G`,
	"noPadding": `ManageSecurityDeposit-noPadding-ZBa7y`,
	"spaceMarginBottom0": `ManageSecurityDeposit-spaceMarginBottom0-bKfEf`,
	"textBold": `ManageSecurityDeposit-textBold-C2zhM`,
	"textBolder": `ManageSecurityDeposit-textBolder-unc6X`,
	"textNormal": `ManageSecurityDeposit-textNormal-CoPUJ`,
	"textDarkBlue": `ManageSecurityDeposit-textDarkBlue-jVd9h`,
	"textLightBlue": `ManageSecurityDeposit-textLightBlue-y7j7V`,
	"textLightSandleGreen": `ManageSecurityDeposit-textLightSandleGreen-YmjWE`,
	"textLightBrown": `ManageSecurityDeposit-textLightBrown-LvbI9`,
	"textMediumMaroon": `ManageSecurityDeposit-textMediumMaroon-_3GbW`,
	"textBrown": `ManageSecurityDeposit-textBrown-ZU8Qw`,
	"textMaroon": `ManageSecurityDeposit-textMaroon-I2boX`,
	"textDarkBrown": `ManageSecurityDeposit-textDarkBrown-y_XJl`,
	"textMediumBrown": `ManageSecurityDeposit-textMediumBrown-xGleo`,
	"textSkyBlue": `ManageSecurityDeposit-textSkyBlue-u_xQm`,
	"textGray": `ManageSecurityDeposit-textGray-MCGF_`,
	"errorMessage": `ManageSecurityDeposit-errorMessage-py2tN`,
	"userText": `ManageSecurityDeposit-userText-Ynr7C`,
	"panelHeader": `ManageSecurityDeposit-panelHeader-e0nEi`,
	"exportSection": `ManageSecurityDeposit-exportSection-vngiY`,
	"exportSectionGridSub": `ManageSecurityDeposit-exportSectionGridSub-jvhPy`,
	"exportText": `ManageSecurityDeposit-exportText-IFw9O`,
	"exportLinkImg": `ManageSecurityDeposit-exportLinkImg-ThpnH`,
	"exportImg": `ManageSecurityDeposit-exportImg-NHsx_`,
	"linkBtn": `ManageSecurityDeposit-linkBtn-NsUrg`,
	"table": `ManageSecurityDeposit-table-cvqwF`,
	"tableRow": `ManageSecurityDeposit-tableRow-QxTiZ`,
	"tableCell": `ManageSecurityDeposit-tableCell-xsNlz`,
	"formGroup": `ManageSecurityDeposit-formGroup-ucFKD`,
	"marginTop0": `ManageSecurityDeposit-marginTop0-V_Vu4`,
	"marginBottom20": `ManageSecurityDeposit-marginBottom20-UBCsG`,
	"bannerImageBg": `ManageSecurityDeposit-bannerImageBg-Ilnhj`,
	"bannerDelete": `ManageSecurityDeposit-bannerDelete-Tljyw`,
	"exportLink": `ManageSecurityDeposit-exportLink-iUvEB`,
	"seachContent": `ManageSecurityDeposit-seachContent-oPT_3`,
	"marginBottom9": `ManageSecurityDeposit-marginBottom9-hmpbX`,
	"spaceTop52": `ManageSecurityDeposit-spaceTop52-G044y`,
	"profileViewInner": `ManageSecurityDeposit-profileViewInner-_jmT2`,
	"profileViewMain": `ManageSecurityDeposit-profileViewMain-Ev1sf`,
	"profileViewlabel": `ManageSecurityDeposit-profileViewlabel-efCLB`,
	"profileViewMainContent": `ManageSecurityDeposit-profileViewMainContent-O2l1I`,
	"reviewsFormStar": `ManageSecurityDeposit-reviewsFormStar-vlk02`,
	"addLanguageText": `ManageSecurityDeposit-addLanguageText-klGJv`,
	"btn": `ManageSecurityDeposit-btn-lQ5Gu`,
	"btnPrimary": `ManageSecurityDeposit-btnPrimary-mL9yU`,
	"btnPrimaryBorder": `ManageSecurityDeposit-btnPrimaryBorder-ua6fZ`,
	"btnSecondary": `ManageSecurityDeposit-btnSecondary-oDulg`,
	"btnLink": `ManageSecurityDeposit-btnLink-dGV4K`,
	"btnLinkPrimary": `ManageSecurityDeposit-btnLinkPrimary-iHdhF`,
	"btnLinkSecondary": `ManageSecurityDeposit-btnLinkSecondary-TivqD`,
	"searchFilterPopover": `ManageSecurityDeposit-searchFilterPopover-uRMe6`,
	"searchFilterPopoverFull": `ManageSecurityDeposit-searchFilterPopoverFull-BlWTl`,
	"searchFilterPopoverOverlay": `ManageSecurityDeposit-searchFilterPopoverOverlay-cPzEo`,
	"searchFilterPopoverContent": `ManageSecurityDeposit-searchFilterPopoverContent-tG0Jr`,
	"searchFilterCloseIcon": `ManageSecurityDeposit-searchFilterCloseIcon-I393W`,
	"searchFilterPopoverFooter": `ManageSecurityDeposit-searchFilterPopoverFooter-fjqLF`,
	"displayTable": `ManageSecurityDeposit-displayTable-OzyEo`,
	"displayTableRow": `ManageSecurityDeposit-displayTableRow-Wo1YI`,
	"displayTableCell": `ManageSecurityDeposit-displayTableCell-BJHnr`,
	"displayInlineBlock": `ManageSecurityDeposit-displayInlineBlock-SO4HX`,
	"fullWidth": `ManageSecurityDeposit-fullWidth-xLCQU`,
	"captionTitle": `ManageSecurityDeposit-captionTitle-nSeQO`,
	"showTabletSection": `ManageSecurityDeposit-showTabletSection-kbXD5`,
	"incrementDecrementButton": `ManageSecurityDeposit-incrementDecrementButton-pr2Vz`,
	"commonBorder": `ManageSecurityDeposit-commonBorder-WMPan`,
	"textCenter": `ManageSecurityDeposit-textCenter-tXqg5`,
	"searchFilterPopoverHeader": `ManageSecurityDeposit-searchFilterPopoverHeader-ht8Eo`,
	"textSize": `ManageSecurityDeposit-textSize-ReH7S`,
	"capitalizeText": `ManageSecurityDeposit-capitalizeText-lxxa0`,
	"hideBothTabletAndMobile": `ManageSecurityDeposit-hideBothTabletAndMobile-M8vGO`,
	"btnFontsize": `ManageSecurityDeposit-btnFontsize-xy7uQ`,
	"transmissionBottom": `ManageSecurityDeposit-transmissionBottom-JeOXs`,
	"marginTop20": `ManageSecurityDeposit-marginTop20-E7IuW`,
	"marginRight15": `ManageSecurityDeposit-marginRight15-_NNbP`,
	"marginNone": `ManageSecurityDeposit-marginNone-MsrVu`,
	"paddingNone": `ManageSecurityDeposit-paddingNone-plwFB`,
	"infoPadding": `ManageSecurityDeposit-infoPadding-euIiL`,
	"pullRight": `ManageSecurityDeposit-pullRight-dFgOM`,
	"displayFlex": `ManageSecurityDeposit-displayFlex-k5o5s`,
	"hideTabletSection": `ManageSecurityDeposit-hideTabletSection-cWZth`,
	"applyBtnDesktop": `ManageSecurityDeposit-applyBtnDesktop-KCN_m`,
	"applyBtn": `ManageSecurityDeposit-applyBtn-uFD1v`,
	"applyBtnDesktopRight": `ManageSecurityDeposit-applyBtnDesktopRight-JuR_q`,
	"applyBtnDesktopNoPaddingRight": `ManageSecurityDeposit-applyBtnDesktopNoPaddingRight-bKgPA`,
	"activeItem": `ManageSecurityDeposit-activeItem-mAtCp`,
	"activeSection": `ManageSecurityDeposit-activeSection-bbYNG`,
	"currencyAndLangGrid": `ManageSecurityDeposit-currencyAndLangGrid-VLpKD`,
	"ChangeToUpperCase": `ManageSecurityDeposit-ChangeToUpperCase-w_FZP`,
	"marginBottom": `ManageSecurityDeposit-marginBottom-QGGPN`,
	"active": `ManageSecurityDeposit-active-qBVRZ`,
	"marginLR": `ManageSecurityDeposit-marginLR-SD6X_`,
	"mbFullWidth": `ManageSecurityDeposit-mbFullWidth-rCqhW`
};
module.exports = ___CSS_LOADER_EXPORT___;
